import React from 'react';
import { useFormContext, useWatch } from 'react-hook-form';
import { SendApplicationFormTemplates, SendApplicationFormValues } from '../../types';
import Grid from '@mui/material/Grid2';
import { RadioGroupField, SelectField } from 'components/form';
import { creditAppTemplateOptions, TestIds } from 'modules/sendCreditApplication/constants';
import { SelectOption } from 'global';
import { Typography } from '@mui/material';

interface Props {
  lenderProfilesWithOcaOptions: SelectOption[];
}

export const TemplateSection = ({ lenderProfilesWithOcaOptions }: Props) => {
  const {
    control,
    formState: { errors },
  } = useFormContext<SendApplicationFormValues>();

  const creditApplicationTemplate = useWatch({
    control,
    name: 'creditApplicationTemplate',
  });

  const isLenderTemplate = creditApplicationTemplate === SendApplicationFormTemplates.Lender;
  const isLenderOcaAvailable = !!lenderProfilesWithOcaOptions.length;

  return (
    <Grid container spacing={2} pt={'12px'}>
      <Grid size={{ xs: 12 }}>
        <RadioGroupField
          row
          control={control}
          name="creditApplicationTemplate"
          options={creditAppTemplateOptions}
          data-testid={TestIds.TemplateRadioGroup}
        />
      </Grid>

      {isLenderTemplate && isLenderOcaAvailable && (
        <Grid size={{ xs: 12, md: 3 }}>
          <SelectField
            label="Lender Credit Application Template"
            control={control}
            name="lenderProfileId"
            options={lenderProfilesWithOcaOptions}
            variant="outlined"
            error={!!errors.lenderProfileId}
            helperText={errors.lenderProfileId?.message}
            required
            data-testid={TestIds.LenderCreditAppTemplate}
          />
        </Grid>
      )}

      {isLenderTemplate && !isLenderOcaAvailable && (
        <Typography component="span" color="error" variant="body2">
          No available credit application templates found for your account. Please contact your admin
        </Typography>
      )}
    </Grid>
  );
};
